const PathConstants = {
  HOME: "/",
  DASHBOARD: "/dashboard",
  FEATURE: "/feature",
  PRICING: "/pricing",
  LOGIN: "/login",
  SIGNUP: "/signup",
  TERMSANDCONDITIONS: "/terms/conditions",
  PRIVACYPOLICY: "/privacy/policy",
  CONTACT: "/support",
  FORGOTPASSWORD: "/forgot/password",
  VIEWREQUEST: "/view/request",
  EDITENDPOINT: "/edit/endpoint",
  NEWENDPOINT: "/create/endpoint",
  FORMEXAMPLE: "/form/example",
};

export default PathConstants;
